import { Injectable } from '@angular/core';
import { ExecutionResult, LcsApiService } from '@lcs/shared/api';
import { BlockedPhoneNumberInput } from 'generated/graphql-types';
import { Observable } from 'rxjs';
import { BlockedPhoneNumberDetailSaveModel } from '../models/blocked-phone-number-detail-save.model';
import { SaveBlockedPhoneNumber, SaveBlockedPhoneNumberVariables } from '../queries/generated/SaveBlockedPhoneNumber';
import { SaveBlockedPhoneNumberMutation } from '../queries/save-blocked-phone-number.graphql';

@Injectable({ providedIn: 'root' })
export class AddBlockedPhoneNumberApiService {
   constructor(private apiService: LcsApiService) {}

   create(
      blockedPhoneNumberDetail: BlockedPhoneNumberDetailSaveModel
   ): Observable<ExecutionResult<SaveBlockedPhoneNumber>> {
      const fields: (keyof BlockedPhoneNumberInput)[] = ['phoneNumber', 'comment', 'accountId'];
      return this.apiService.query<SaveBlockedPhoneNumber, SaveBlockedPhoneNumberVariables>({
         query: SaveBlockedPhoneNumberMutation,
         variables: {
            blockedPhoneNumber: {
               ...blockedPhoneNumberDetail,
               fields: fields,
            },
         },
      });
   }
}
